var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [_vm._t("breadcrumbs"), _vm._v(" "), _vm._t("totals")],
        2
      ),
      _vm._v(" "),
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _vm._t("annotation-switcher"),
      _vm._v(" "),
      _c("DocsTable", {
        attrs: {
          mainAnnotation: _vm.mainAnnotation,
          metadata: _vm.metadata,
          dir: _vm.dir,
          html: _vm.html,
          disabled: _vm.disabled,
          showHits: _vm.showDocumentHits,
          data: _vm.docRows,
        },
        on: { changeSort: _vm.changeSort },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _vm._t("sort"),
          _vm._v(" "),
          _vm.hasHits
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showDocumentHits = !_vm.showDocumentHits
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.showDocumentHits
                          ? _vm.$t("results.table.hideHits")
                          : _vm.$t("results.table.showHits")
                      ) +
                      "\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("export"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }